import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { PageSchema } from '@/components/SEOSchema';
import { SITE_URL } from '@/lib/seo';

export default function AboutPage() {
  const { t, i18n } = useTranslation();
  const homePath = i18n.language === 'pt' ? '/' : `/${i18n.language}/`;
  const aboutUrl = `${SITE_URL}${i18n.language === 'pt' ? '/about/' : i18n.language === 'de' ? '/de/ueber-uns/' : '/en/about/'}`;

  return (
    <div className="min-h-screen bg-background-50">
      <PageSchema
        type="AboutPage"
        name={t('about.title')}
        description="Learn more about the CSSBuy Spreadsheet Resource Hub, an independent informational resource with links, guides and buying information."
        url={aboutUrl}
        lang={i18n.language}
      />
      <Navbar />

      <div className="w-full px-4 md:px-6 lg:px-10 pt-24 pb-16">
        <div className="max-w-3xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6">
            <Link to={homePath} className="hover:text-primary-600 transition-colors">{t('nav.home')}</Link>
            <i className="ri-arrow-right-s-line text-xs" />
            <span className="text-foreground-600">{t('nav.about')}</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-semibold mb-8">{t('about.title')}</h1>

          <div className="prose max-w-none space-y-6">
            <p className="text-foreground-600 leading-relaxed">{t('about.text1')}</p>
            <p className="text-foreground-600 leading-relaxed">{t('about.text2')}</p>

            <div className="bg-primary-50/50 border border-primary-200/50 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">{t('about.mission')}</h2>
              <p className="text-foreground-600">{t('about.missionText')}</p>
            </div>

            <div className="bg-foreground-50 border border-foreground-200/50 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">{t('about.disclaimer')}</h2>
              <p className="text-foreground-600 text-sm italic">{t('about.disclaimerText')}</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}